<template>
  <div v-if="isLoading || !isEdit || !empty(pageInfo)">
    <a-card class="style1 pages w-100" :class="[isDesktop ? 'desktop' : 'mobile']">
      <a-form :form="form" :label-col="isDesktop ? { span: 4 } : {}" :wrapper-col="isDesktop ? { span: 20 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
        <a-form-item label="Title">
          <a-input
            @change="onGenerateSlug"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input title!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Slug">
          <a-input
            v-decorator="[
              'slug',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input pages slug!',
                  },
                ],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="User Icon">
          <a-input
            v-decorator="[
              'icon_img',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please add Icon URL!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Download Video URL">
          <a-input
            v-decorator="[
              'download_video',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input download video URL!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Read Blog URL">
          <a-input v-decorator="['read_blog']"></a-input>
        </a-form-item>
        <a-form-item label="Embed Video URL">
          <a-input
            v-decorator="[
              'embed_video',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please add embed_video video URL!',
                  },
                ],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Description">
          <wysiwyg
            v-model="description"
            v-decorator="[
              'description',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please input description!'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-tag color="red" class="d-block p-1" v-if="!empty(error)">{{ error }}</a-tag>
          <a-button type="primary" html-type="submit" :loading="isLoading">{{ isEdit ? 'Update Page' : 'Create Page' }}</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
  <div v-else>
    <h2>Page not found</h2>
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminPages' })">Go to pages list</a-button>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AdminService from '@/services/AdminService';
import { empty, slugData } from '@/utils';
import { get, find } from 'lodash';
export default {
  data() {
    return {
      showPreview: false,
      error: '',
      pageInfo: {},
      isLoading: false,
      description: '',
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'page',
    });
  },
  computed: {
    ...mapState(['settings']),
    isEdit() {
      return this.$route.name === 'AdminMonthlyPageDetail';
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  watch: {
    $route: {
      async handler(route) {
        if (this.isEdit) {
          this.doGetPageInfo(route.params.pageSlug);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$title = this.$route.meta.title;
  },
  methods: {
    empty,
    onGenerateSlug() {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          slug: slugData(this.form.getFieldValue('title'), '-'),
        });
      });
    },
    async doGetPageInfo(pageSlug) {
      try {
        this.isLoading = true;
        const resp = await AdminService.monthlyPages.getAll();
        this.pageInfo = find(resp, item => item.slug === pageSlug);
        this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },

    doInitData() {
      if (this.isEdit) {
        this.description = this.pageInfo.description;

        this.$nextTick(() => {
          this.form.setFieldsValue({
            title: this.pageInfo.title,
            slug: this.pageInfo.slug,
            icon_img: this.pageInfo.icon_img,
            read_blog: this.pageInfo.read_blog,
            download_video: this.pageInfo.download_video,
            embed_video: this.pageInfo.embed_video,
            description: this.pageInfo.description,
          });
        });
      }
    },
    validateInput(rule, value, callback, message) {
      if (empty(value) || value === '<br>') {
        return callback(message);
      }
      callback();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            this.error = '';
            const dataSubmit = {};
            const paramsRequired = ['title', 'slug', 'icon_img', 'download_video', 'read_blog', 'embed_video', 'description'];

            paramsRequired.forEach(item => {
              if (!empty(values[item])) {
                dataSubmit[item] = values[item];
              }
            });

            if (!this.isEdit) {
              await AdminService.monthlyPages.create(dataSubmit);
              this.$notification['success']({
                message: 'Create successful.',
                content: `${dataSubmit.title} was created successfully.`,
              });
            } else {
              dataSubmit.id = this.pageInfo.id;
              await AdminService.monthlyPages.update(this.pageInfo.id, dataSubmit);
              this.$notification['success']({
                message: 'Update successful.',
                content: `${dataSubmit.title} was updated successfully.`,
              });
            }
            this.$router.push({ name: 'AdminMonthlyPages' });
          } catch (error) {
            console.log(error);
            this.error = get(error, 'response.data.error', error.message);
          } finally {
            this.isLoading = false;
          }
        } else {
          window.parent.scrollTo(0, 0);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<style lang="scss">
.pages {
  &.mobile {
    .editr--toolbar {
      height: 100%;
      flex-wrap: wrap;
      .vw-btn-separator {
        display: none;
      }
    }
  }
}
</style>
